import { useQuery } from '@tanstack/react-query';
import { IResourceGroup } from 'models/capacity/capacityDashboard.model';
import api from 'services/api/api';
export interface IQueryResourceGroup {
	possui_recurso: boolean;
}
export const getResourceGroup = async (
	query?: IQueryResourceGroup
): Promise<IResourceGroup[]> => {
	const response = await api.get('/dashboardCapacidade/gruposRecursoSelect', {
		params: query,
	});
	return response.data;
};

export const useResourceGroupList = (query?: IQueryResourceGroup) => {
	return useQuery(['resource-group-list'], () => getResourceGroup(query), {
		refetchOnWindowFocus: false,
	});
};
